import axios from 'axios';

export default {
  namespaced: true,

  state: {
    surveys: [],
    forRed:[],
    chosenSubjectForSurvey:0
  },

  getters: {
    surveys: state => state.surveys,
    getForRed: state => state.forRed,
    getChosenSubjectForSurvey: state => state.chosenSubjectForSurvey,
  },

  actions: {
    setSurveys({ commit, state }, data) {
      state.surveys = data;
    },
    unsetSurvey({ commit, state }, survey) {
      const index = state.surveys.indexOf(survey);
      state.surveys.splice(index, 1);
    },

    setForRed({state},questions){

      state.forRed=questions

    },
    setChosenSubjectForSurvey({state},subjectID){
      state.chosenSubjectForSurvey=subjectID
    }
  },
};
